<div class="details-body-wrapper">
  <app-users-list
    [filters]="filters"
    [entityType]="'provider'"
    [addPermission]="'create provider user'"
  >
  </app-users-list>
</div>
